import SoundService from 'src/modules/sound/soundService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'SOUND_FORM';

const soundFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SoundService.find(id);
      }

      dispatch({
        type: soundFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundFormActions.INIT_ERROR,
      });

      getHistory().push('/sound');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: soundFormActions.CREATE_STARTED,
      });

      await SoundService.create(values);

      dispatch({
        type: soundFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.sound.create.success'),
      );

      getHistory().push('/sound');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: soundFormActions.UPDATE_STARTED,
      });

      await SoundService.update(id, values);

      dispatch({
        type: soundFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.sound.update.success'),
      );

      getHistory().push('/sound');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default soundFormActions;
